app.service('loading', function(console, html, activeElement){
	var $self;

	function start(){
		if(!$self){
			init();
		}
		activeElement.set(); //Zapisanie aktywnego elementu przed pokazaniem loadingu
		html.add('show-loading');
		console.log('LOADING start');
	}
	function stop(){
		html.remove('show-loading');
		activeElement.focus();
		console.log('LOADING stop');
	}
	let isOneInit = false;
	function init(){
		if(!isOneInit){
			isOneInit = true;
			$self = $('<div id="loading"/>').appendTo($('body'));		//TODO zastanowić się czy aby tego nie zmienić na wzór desktpu
		}
	}
	function redirect(url){
		console.log('LOADING redirect');
		start();
		//remodal blokuje javascript jesli jego animacja się nie zakończy
		requestAnimationFrame(function() {
			document.location.href = url;
		});
	}
	function reload(){
		console.log('LOADING reload');
		start();
		location.reload(true);
	}
	$(window).on('pagehide', function(){
		stop();
	});
	return {
		start,
		stop,
		redirect,
		reload
	};
});
